import { useSelector } from 'react-redux';
import { qualYearSelect } from 'Redux/Selectors/Contracts.Globals.Selectors';

const useActiveQualificationYear = () => {
	const { isLoaded: activeQualYearLoaded, active: activeQualYear } = useSelector(qualYearSelect);
	return { activeQualYearLoaded, activeQualYear };
};

export default useActiveQualificationYear;